import { useState, useEffect } from "react";
import { Box, Typography, Tooltip, IconButton, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseMagLandings } from "../UseMagLandings";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import CustomPagination from "../../../components/CustomPagination";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";

export default function LandingGrid(props) {
  const { deleteGroupArticle, UpdateGroupArticle, UpdateHomePageMags } =
    UseMagLandings();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [itemRes, setItemRes] = useState([]);
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    setFilt([
      {
        columnField: "productName",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  useEffect(() => {
    if (props.rows) {
      setItemRes(props.rows);
    }
  }, [props.rows]);

  const funcRefList = () => {
    setProgress(true);
    UpdateHomePageMags(props.groupDetails.id, (callback) => {
      props.callback(props.groupDetails.landingID, props.groupDetails.id);
    });
  };

  const columns = [
    {
      field: "rowIndex",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
    },
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "articleID",
      width: 90,
      align: "center",
      headerName: "کد مقاله",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "نام مقاله",
      width: 300,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "author",
      headerName: "نویسنده",
      align: "center",
      width: 160,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.author}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 140,
      headerAlign: "center",
      align: "left",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  UpdateGroupArticle(model, () => {
                    props.callback(
                      props.groupDetails.landingID,
                      props.groupDetails.id
                    );
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" sx={{}} />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                };

                if (cellValues.row.rowIndex + 1 == itemRes.length + 1) {
                  return;
                } else {
                  UpdateGroupArticle(model, () => {
                    props.callback(
                      props.groupDetails.landingID,
                      props.groupDetails.id
                    );
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" sx={{}} />
            </IconButton>
          </>
        );
      },
    },
    {
      field: "search",
      width: 220,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو مقاله"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem", mb: 5 }}>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={itemRes ? itemRes : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={itemRes && itemRes.length ? itemRes.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            funcRefList: funcRefList,
            nofab: true,
            isMagItems: true,
            isLtr: true,
            rowCount: itemRes && itemRes.length ? itemRes.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />

      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"مقاله"}
        callback={() => {
          setProgress(true);
          deleteGroupArticle(deleteState.id, () => {
            props.callback(props.groupDetails.landingID, props.groupDetails.id);
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
